<template>
  <div>
    <a-tooltip placement="top" title="Eliminar">
      <a-button type="link" @click="handleClick">
        <template #icon>
          <DeleteOutlined
            :style="{
              fontSize: '17.5px',
            }"
          />
        </template>
      </a-button>
    </a-tooltip>
    <a-modal
      :visible="visible"
      width="450px"
      :body-style="bodyStyle"
      :footer="null"
      @cancel="handleCloseModal"
    >
      <div class="container__inactive">
        <img class="image__delete" :src="deleteImage" alt="delete" />
        <h1 class="text__alert">¿Estás seguro de eliminar la cola {{ queue?.name }}?</h1>
      </div>
      <p class="text">Recuerda que se tomarán las siguientes acciones:</p>
      <ul>
        <li>Se desconectarán los canales asignados.</li>
        <li>Los tickets asociados a este canal se resolverán de manera automática</li>
        <li>Los usuarios asignados a esta cola se desvincularán</li>
        <li>Las llamadas asociadas se finalizarán</li>
      </ul>

      <div class="button__disabled">
        <a-button style="width: 100%" class="footer__delete" type="primary" @click="changeStatus">
          Eliminar cola
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { defineComponent, createVNode, h } from "vue";
import { QuestionCircleOutlined, DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";
import deleteImage from "@/app/common/assets/delete.png";
import { fetchValidateQueuesBots } from "@/app/entities/services";

export default defineComponent({
  components: {
    DeleteOutlined,
  },
  props: {
    queue: { required: true, type: Object },
    validateBot: { required: false, type: Boolean },
  },
  data() {
    return {
      visible: false,
      bodyStyle: {
        height: "400px",
        loading: false,
      },
    };
  },
  computed: {
    isActive() {
      return this.queue.status === 1 ? true : false;
    },
    user() {
      return this.$store.getters["getDataUser"];
    },
  },
  methods: {
    handleCloseModal() {
      this.visible = false;
    },
    async handleValidateQueuesBots() {
      try {
        if (this.queue?.id) {
          const response = await fetchValidateQueuesBots(this.queue?.id);
        }
      } catch (error) {
        if (error.status === 400) {
          const errorMessage = error?.getErrorMessage?.() || "";
          const regex = /([A-Za-z_]\w*):\s*([\s\S]*?)(?=(?:[A-Za-z_]\w*):|$)/gu;
          let match;
          const data = {};

          while ((match = regex.exec(errorMessage)) !== null) {
            const key = match[1];
            const value = match[2];
            data[key] = value;
          }

          // Ahora puedes acceder a cada valor
          const chatbot_total = Number(data.chatbot_total) || 0;
          const beexai_total = Number(data.beexai_total) || 0;
          const message = [
            chatbot_total > 0 && beexai_total > 0
            ? `Esta cola no puede ser eliminada porque está vinculada a ${chatbot_total} chatbot${chatbot_total > 1 ? "s" : ""} y ${beexai_total} bot${beexai_total > 1 ? "s AI" : " AI"} activos.`
            : chatbot_total > 0 
            ? `Esta cola no puede ser eliminada porque está vinculada a ${chatbot_total} chatbot${chatbot_total > 1 ? "s activos" : " activo"}.`
            : beexai_total > 0 
            ? `Esta cola no puede ser eliminada porque está vinculada a ${beexai_total} bot${beexai_total > 1 ? "s AI activos" : " AI activo"}.`
            : ""
            ].filter(Boolean).join(" ");

          const chatBot = data.chatbot ? data.chatbot.split(",").map(v => v.trim()) : [];
          const beexAI = data.beexai ? data.beexai.split(",").map(v => v.trim()) : [];
          await this.handleErrorModal(
            message,
            beexAI,
            chatBot
          );
        } else {
          this.$message.warning("Algo salió mal, por favor, vuelve a intentarlo.");
        }
        throw error;
      }
    },
    async handleClick() {
      if (this.validateBot) {
        await this.handleValidateQueuesBots();
      }
      if (this.queue.channels_customer.length == 0) {
        Modal.confirm({
          title: `¿Estás seguro de eliminar la cola ”${this.queue.name}”?`,
          icon: createVNode(QuestionCircleOutlined),
          content:
            "Los tickets y llamadas que se encuentren siendo atendidas por los usuarios asignados a esta cola se resolverán de manera automática.",
          onOk: () => this.changeStatus(),
          centered: true,
          okText: "Eliminar",
          cancelText: "Cancelar",
        });
      } else {
        this.visible = true;
      }
    },
    async handleErrorModal(title, botIA, chatBot) {
      const text = botIA.length > 0 && chatBot.length > 0
          ? "Inactiva los chatbots y bots AI vinculados, o reemplaza la cola de transferencia en los chatbots o la cola seleccionada en los bots AI."
          : "Inactiva los bots AI vinculados o reemplaza la cola por otra en su configuración.";

      Modal.confirm({
        title: title,
        icon: createVNode(InfoCircleOutlined),
        content:  createVNode("div", { class: "inactive-bot-modal" }, [
                  createVNode("p", { class: "text-base font-medium mb-2" }, text),
                  // ChatBots
                  chatBot.length > 0
                    ? createVNode("div", {}, [
                        createVNode(
                          "span",
                          { class: "font-medium mb-1" },
                          "ChatBots vinculados"
                        ),
                        createVNode(
                          "ul",
                          { class: "list-disc list-inside text-sm text-gray-600" },
                          chatBot.map((c) => createVNode("li", { key: c }, c))
                        ),
                      ])
                    : null,
                  botIA.length > 0
                    ? createVNode("div", {}, [
                        // Bots AI
                        createVNode(
                          "span",
                          { class: "font-medium mb-1" },
                          "Bots AI vinculados"
                        ),
                        createVNode(
                          "ul",
                          { class: "list-disc list-inside text-sm text-gray-600 mb-2" },
                          botIA.map((bot) => createVNode("li", { key: bot }, bot))
                        ),

                        
                      ])
                    : null,
                ]),
                
        centered: true,
        okText: "Entendido",
        cancelButtonProps: { style: { display: "none" } },
      });
    },
    async changeStatus() {
      try {
        await this.$store.dispatch("deleteQueue", this.queue);
        this.$emit("update");
        this.queue.agents.map((agent) => {
          this.$store.dispatch("callHangUp", {
            customer_id: this.user.customer.id,
            user_id: agent.id,
          });
        });
        this.$message.success(`Se ha eliminado la cola “${this.queue.name}” correctamente`);

        this.visible = false;
      } catch (error) {
        console.log(error.data);
        this.visible = false;
        // const botsList = error.data?.bots?.map((bot) => bot.name);
        // if (botsList) {
        //   Modal.warning({
        //     title: "Esta cola se encuentra vinculada a un chatbot",
        //     content: h("div", {}, [
        //       h(
        //         "p",
        //         { style: { margin: 0 } },
        //         "Debes inactivar el chatbot vinculado o modificar su cola de destino."
        //       ),
        //       h("p", { style: { margin: 0 } }, "Chatbots vinculados:"),
        //       h(
        //         "ul",
        //         { style: { margin: 0 } },
        //         botsList.map((bot) => h("li", bot))
        //       ),
        //     ]),
        //     centered: true,
        //   });
        
        this.$message.warning("Algo salió mal, por favor, vuelve a intentarlo.");
        
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.container__inactive
  margin-top: 30px
  text-align: center

.image__delete
  margin-bottom: 10px
.text__alert
  font-size: 16px
  font-weight: 600
.button__disabled
  margin-top: 10px
.text
  margin-bottom: 20px
:global(.font-medium .mb-1)
  font-weight: 600 !important
</style>
